import React, { useContext, useState, useEffect } from "react";
import { useSpeakingDetector } from "../../hooks/useSpeakingDetector";
import { ThemeContext } from "../../contexts/ThemeContext";
import ParticipantAudio from "./ParticipantAudio";
import MuteComponent from "./MuteComponent";
import DegradedBadge from "./DegradedBadge";

export default function MeetingOneToThree({
  users,
  mediasTools,
  activeSpeakerId,
}) {
  const { localStream, degradedUserIds } = mediasTools;
  const { theme } = useContext(ThemeContext);
  const [color, setColor] = useState(theme === "dark" ? "#fff" : "#023377");
  const isSpeaking = useSpeakingDetector(localStream, /*isMuted*/ false);
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => setImageError(true);

  useEffect(() => {
    setColor(theme === "dark" ? "#fff" : "#023377");
  }, [theme]);

  return (
    <div className="row mb-4" style={{ "--participant-count": users.length }}>
      {users.map((participant, index) => {
        const track = participant.stream?.getVideoTracks?.()[0];
        return (
          <div
            key={`${index}_${participant.userId}`}
            className={`video-container-wrtc col col-12 col-md-${
              users.length === 1 ? 12 : users.length === 2 ? 6 : 4
            }`}
          >
            {!participant.audioOn && <MuteComponent />}
            {degradedUserIds?.includes(participant.userId) && <DegradedBadge />}
            {participant.videoOn && track ? (
              <>
                <video
                  ref={(ref) => {
                    if (ref && ref.srcObject !== participant.stream) {
                      ref.srcObject = participant.stream;
                    }
                  }}
                  autoPlay
                  muted={participant.isLocal}
                  playsInline
                  style={{
                    cursor: "pointer",
                    transform: participant.isLocal ? "scaleX(-1)" : "none",
                    objectFit: "cover",
                    width: "100%",
                    borderRadius: "10px",
                  }}
                  className="mon-composant-meet-video-1-2-3"
                />
              </>
            ) : (
              <div className="video-off-blur">
                <ParticipantAudio participant={participant} />
                <img
                  src={participant.userImage}
                  alt="Background"
                  className="blur-bg"
                  onError={handleImageError}
                />
                <div
                  className={`avatar-wrapper ${
                    (participant.isLocal && isSpeaking) ||
                    (!participant.isLocal &&
                      activeSpeakerId === participant.userId)
                      ? "speaking"
                      : ""
                  }`}
                >
                  {participant.userImage && !imageError ? (
                    <img
                      src={participant.userImage}
                      alt="User"
                      className="user-avatar"
                      onError={handleImageError}
                    />
                  ) : (
                    <div
                      className="user-avatar"
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "clamp(28px, 8vw, 50px)",
                        color,
                      }}
                    >
                      {participant.displayName[0] +
                        participant.displayName.split(" ")[1].charAt(0)}
                    </div>
                  )}
                </div>
              </div>
            )}
            <span style={nameOverlayStyle}>{participant.displayName}</span>
          </div>
        );
      })}
    </div>
  );
}

const nameOverlayStyle = {
  position: "absolute",
  bottom: "12px",
  left: "19px",
  zIndex: 2,
  color: "#fff",
  fontSize: "clamp(12px, 1.4vw, 15px)",
  fontWeight: 600,
  backgroundColor: "rgba(0,0,0,0.5)",
  padding: "2px 8px",
  borderRadius: "6px",
  pointerEvents: "none",
  maxWidth: "80%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
